import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { MgButtonModule } from '@app/src/app/button';
import { MgIconModule } from '@app/src/app/icon';

import { XlsListUploaderModule } from '@shared/components/XlsListUploader';
import { XlsListUploaderDialogComponent } from '@shared/components/XlsListUploader/XlsListUploaderDialog/XlsListUploaderDialog.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,
    MgIconModule,
    XlsListUploaderModule,

    // External dependencies
    CommonModule,
    MatDialogModule,
  ],
  declarations: [XlsListUploaderDialogComponent],
  exports: [XlsListUploaderDialogComponent],
})
export class XlsListUploaderDialogModule {}
